import {InjectionToken} from '@angular/core';

export const BASE_CLIENT = new InjectionToken<BaseClient>('BASE_CLIENT');

export interface BaseClient {
  gateway?: string;
  ignores?: string[];
  dev?: {
    username?: string,
    password?: string
  };
  wechat?: {
    debug?: boolean,
    appId?: string,
    auth?: boolean;
  };
  wechatMicro?: {
    auth?: boolean;
  };
  android?: {
    auth?: boolean;
  };
  browser?: {
    auth?: boolean;
  };
  ios?: {
    auth?: boolean;
  };
  yunzaiIm?: {
    auth?: boolean;
  };
  dingtalk?: {
    auth?: boolean;
  };
  openDev?: boolean;
  alwaysBrowser?: boolean;
  mobileVersion: "V5" | "V6" | null;
}
